// Utility to apply theme mode as data attribute to document body
// This allows CSS files to use [data-theme="dark"] selectors

export const applyThemeToBody = (mode) => {
    document.documentElement.setAttribute('data-theme', mode);
    document.body.setAttribute('data-theme', mode);
};
